import { AppModal } from 'shared/UI/UIKit/Modal';
import { BellScheduleForm } from 'entities/bell-schedule/form';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppCopyIcon } from 'shared/UI/UIKit/icons/Copy';
import type { BellSchedule } from 'services/api';
import { useBellScheduleCopy } from '../model';
import styles from './styles.module.scss';

interface BellScheduleCopyProps {
  bellSchedule: BellSchedule;
  refreshTable: () => void;
}

export const BellScheduleCopy = ({ bellSchedule, refreshTable }: BellScheduleCopyProps) => {
  const {
    state: { modalVisible, form },
    methods: { showModal, hideModal, onSubmit },
  } = useBellScheduleCopy({ bellSchedule, refreshTable });

  return (
    <>
      <AppCopyIcon className={styles.icon} onClick={showModal} />

      <AppModal
        content={<BellScheduleForm form={form} />}
        title="Новое расписание"
        visible={modalVisible}
        onCancel={hideModal}
        destroyOnClose
        footer={
          <AppFlex direction="row">
            <AppButton type="primary" onClick={onSubmit}>
              Создать
            </AppButton>
            <AppButton type="outline" onClick={hideModal}>
              Закрыть
            </AppButton>
          </AppFlex>
        }
      />
    </>
  );
};
